import React, { memo, useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { Box, ButtonBase } from '@material-ui/core';
import InfoWindow from './InfoWindow';
import { useState } from 'react';

const iconBadgeDim = 2.2;
const useStyles = makeStyles(theme => ({
    customPin: {
        position: "absolute",
        bottom: 0,
        left: "50%",
        userSelect: "none",
        transform: "translate(-50%, 0)",
        zIndex: 1,
        "&:hover": {
            zIndex: 3
        }
    },
    pinOnTop: {
        zIndex: 1

    },
    markerButton:{
        position: "relative",
        outline: 0+"px !important"

    },
    cluster:{
        position: "absolute",
        top: "50%",
        left: "50%",
        userSelect: "none",
        transform: "translate(-50%, -50%)",
        zIndex: 1,
        lineHeight: "1rem",
        color: theme.palette.background.paper,

    },
    center: {
        position: "absolute",
        top: theme.spacing(iconBadgeDim - 0.5),
        left: "50%",
        userSelect: "none",
        transform: "translate(-50%, -50%)",
        lineHeight: theme.spacing(iconBadgeDim)+"px",
        zIndex: 1,
        background: theme.palette.background.paper,
        width: theme.spacing(iconBadgeDim),
        height: theme.spacing(iconBadgeDim),
        textAlign: "center",
        borderRadius: "50%",
        fontWeight: "bold"
    
    },
    clusterText: {
        color: theme.palette.background.paper,
        position: "absolute",
        top: "50%",
        left: "50%",
        userSelect: "none",
        transform: "translate(-50%, -50%)",
        lineHeight: "1.1rem",
        zIndex: 1,
        width: theme.spacing(iconBadgeDim),
        height: theme.spacing(iconBadgeDim),
        textAlign: "center",
        fontWeight: "bold"    
    }
}));

const Marker = props => {
    const { onClick = null, isActive = false, resetActive = ()=>{}, icon = {}, name, info, infoAccessorList, showDetail, showDetailButtonProps, text, align = "bottom", radius = 50, disabledInfo = false, disabled = false} = props
    const classes = useStyles()
    const [showInfo, setShowInfo] = useState(false)
    const iconColor =  icon.color?{color: icon.color}:{}

    const clusterDim = useMemo(()=>{
        if (align !== "bottom") {
            return {
                width: radius,
                height: radius
            }
        }
        else {
            return {}
        }

    },[align, radius])
    const handleClick = (e) => {
        e.stopPropagation()
        onClick && onClick()
        if(disabledInfo){
            return;
        }
        setShowInfo(!showInfo);
    };
    useEffect(()=>{
        setShowInfo(showDetail)
    },[showDetail])

    return ( <Box className={align === "bottom"?classes.customPin: classes.cluster} style={isActive || showInfo ? { zIndex: 3}: {} }>
    <ButtonBase className={classes.markerButton} {...onClick ? { onClick: handleClick } : {}} style={isActive || showInfo ? { zIndex: 2} : disabled?{ zIndex: 0, pointerEvents: "none"}:{}} >
            {text && <div className = {align === "bottom"?classes.center: classes.clusterText}>{text}</div>}
            {<icon.svg  stroke="#fff" strokeWidth={1} {...clusterDim} {...{fontSize: icon.fontSize}} style = {iconColor}/>}
    </ButtonBase >
    {!disabledInfo && <InfoWindow showInfo={showInfo} name={name} info={info} infoAccessorList={infoAccessorList} onClickAway={() => {setShowInfo(false); resetActive();}} showDetailButtonProps={showDetailButtonProps}/>}
    </Box>
    )
};

Marker.propTypes = {
    onClick: PropTypes.func,
    text: PropTypes.string.isRequired,
};

export default memo(Marker);